import React, { useState } from "react";
import { fetchFilterData } from "../../../utils/fetchFilterData";
import axios from "axios";
import userExportAuthenticationConfig from "../../../utils/userExportAuthenticationConfig";
import DefaultButton from "../../styles/materialButtonStyle";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { useTranslation } from "react-i18next";

import { StyledExportButtonWrapper } from "../transactions/styledExportButton";
import { parseAxiosError } from "../../../utils/response";

const FeeExportButton = ({ filterData }) => {
  const { t } = useTranslation("feePage");

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const getFeeCsv = () => {
    filterData.pagination = false;
    let filterUrl = fetchFilterData(filterData);

    axios.get(`/api/fee/export` + filterUrl, userExportAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", `fee_export_${Date.now()}.csv`);

        document.body.appendChild(link);

        link.click();

        delete filterData.pagination;

        setNotification({ ...notification, visible: true, type: "success", message: t("export.success") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <StyledExportButtonWrapper>
      <DefaultButton
        title={t("export.title")}
        className="export-btn"
        color="transparent"
        onClick={getFeeCsv}
      >
        <span className="icon-light-down-arrow" />
      </DefaultButton>
    </StyledExportButtonWrapper>
  );
};

export default FeeExportButton;